// @flow
import React, { PureComponent, Fragment } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { NavLink } from 'react-router-dom';

type Props = {
  activeTab?: string,
  links: { id: string, title: string, link?: string, tab?: string }[],
  onClick?: (tab: string) => void
};

class fidTabs extends PureComponent<Props> {
  renderLinks = () => {
    const { activeTab, links, onClick } = this.props;

    const triggerClassName = dynamicClassName('');
    return links.map<any>((children: any, index) => {
      return (
        <Fragment key={index}>
          <li role="tab" tabIndex="0" className={triggerClassName.build()}>
            {children.link && (
              <NavLink to={children.link} exact activeClassName={'selected'}>
                {children.title}
              </NavLink>
            )}

            {onClick && children.tab && (
              <button className={activeTab === children.tab ? 'selected' : ''} onClick={() => onClick(children.tab)}>
                {children.title}
              </button>
            )}
          </li>
        </Fragment>
      );
    });
  };

  render() {
    if (!this.props.links || !this.props.links.length) {
      return null;
    }

    return (
      <nav className="onglets onglets-fidelite mb-4">
        <ol role="tablist">{this.renderLinks()}</ol>
      </nav>
    );
  }
}

export default fidTabs;
